import type { ReactNode } from 'react'
import classes from './scrollable-content.module.css'

interface Props {
  children: ReactNode
}

export function ScrollableContent(props: Props) {
  return (
    <div className={classes.root} data-id="tidal-sandbox-scrollable-root">
      <div className={classes.content} data-id="tidal-sandbox-scrollable-content">
        <div className={classes.inner}>{props.children}</div>
      </div>
    </div>
  )
}
